import React from 'react'
import { Pressable, StyleSheet } from 'react-native'

import { DS } from '@/design-system'

import * as cth from '@/router/(root)/cth/cthModule'
import * as d10 from '@/router/(root)/daily10/d10Module'
import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'

import { defaultTheme } from '@/components/Mini/theme'


type GameBtnProps = {
  handler: () => void
  label: string
  isDisabled?: boolean
}

function CthPrimaryBtn({handler, label, isDisabled=false}: GameBtnProps) {
  
  const theme = cth.useStore(s => s.theme);

  return (
    <PrimaryBtn theme={theme} handler={handler} label={label} isDisabled={isDisabled}/>
  )
}

function CthSecondaryBtn({handler, label, isDisabled=false}: GameBtnProps) {
  
  const theme = cth.useStore(s => s.theme);

  return (
    <SecondaryBtn theme={theme} handler={handler} label={label} isDisabled={isDisabled}/>
  )
}

function D10PrimaryBtn({handler, label, isDisabled=false}: GameBtnProps) {
  
  const theme = d10.useStore(s => s.theme);

  return (
    <PrimaryBtn theme={theme} handler={handler} label={label} isDisabled={isDisabled}/>
  )
}

function D10SecondaryBtn({handler, label, isDisabled=false}: GameBtnProps) {
  
  const theme = d10.useStore(s => s.theme);

  return (
    <SecondaryBtn theme={theme} handler={handler} label={label} isDisabled={isDisabled}/>
  )
}


function PocketPickPrimaryBtn({handler, label, isDisabled=false}: GameBtnProps) {
  
  const theme = pocketPick.useStore(s => s.theme);

  return ( 
    <PrimaryBtn theme={theme} handler={handler} label={label} isDisabled={isDisabled}/>
  )
}

function PocketPickSecondaryBtn({handler, label, isDisabled=false}: GameBtnProps) {
  
  const theme = pocketPick.useStore(s => s.theme);

  return (
    <SecondaryBtn theme={theme} handler={handler} label={label} isDisabled={isDisabled}/>
  )
}

type BtnVariantProps = {
  theme?: typeof defaultTheme
  handler: () => void
  label: string
  isDisabled?: boolean
}

function PrimaryBtn({theme=defaultTheme, handler, label, isDisabled=false}: BtnVariantProps) {

  const backgroundColor = theme.accent;
  const borderColor = theme.accent;
  const color = theme.accentText;

  return (
    <Btn 
      handler={handler}
      label={label}
      isDisabled={isDisabled} 
      backgroundColor={backgroundColor} 
      borderColor={borderColor} 
      color={color} 
    />
  )
  
}

function SecondaryBtn({theme=defaultTheme, handler, label, isDisabled=false}: BtnVariantProps) {

  const backgroundColor = "transparent";
  //const borderColor = theme.surfaceBorder;
  const borderColor = theme.accent;
  const color = theme.accent;

  return (
    <Btn 
      handler={handler}
      label={label}
      isDisabled={isDisabled} 
      backgroundColor={backgroundColor} 
      borderColor={borderColor} 
      color={color} 
    />
  )
  
}

type BtnProps = {
  handler: () => void
  label: string
  isDisabled: boolean
  backgroundColor: string
  borderColor: string
  color: string
}

function Btn({handler, label, isDisabled, backgroundColor, borderColor, color}: BtnProps) {

  const opacity = isDisabled ? 0.5 : 1

  return (
    <Pressable 
      style={[styles.btn, {backgroundColor, borderColor, opacity}]} 
      onPress={handler}
      disabled={isDisabled}
    >
      <DS.Text variant="Body Large/Medium" style={{color}}>
        {label}
      </DS.Text>
    </Pressable>
  )
}

//or, as DS.Button, //note disabled not incorporated
/*function PrimaryBtn({ theme=defaultTheme, handler, label, isDisabled=false }) {
  return (
    <DS.Button
      variant="Large/Primary"
      type="On Light"
      onPress={handler}
      disabled={isDisabled}
      //style={{ backgroundColor: theme.accent }} //match DS.button
      //styleText={{ color: theme.accentText }} //match DS.button
      style={{ 
        paddingVertical: 14, 
        borderWidth:1, 
        borderRadius: 40, 
        borderColor:theme.accent, 
        backgroundColor: theme.accent 
      }} //match figma
      styleText={{
        fontSize: 18, 
        lineHeight: 21.6, 
        letterSpacing: -0.5, 
        color: theme.accentText 
      }} //match figma
      
    >
      {label}
    </DS.Button>
  )
}

function SecondaryBtn({ theme=defaultTheme, handler, label, isDisabled=false  }) {
  return (
    <DS.Button
      variant="Large/Secondary"
      type="On Light"
      onPress={handler}
      disabled={isDisabled}
      //style={{ borderColor: theme.surfaceBorder }} //match DS.button
      //styleText={{ color: theme.accent  }} //match DS.button
      style={{ 
        paddingVertical: 14, 
        paddingHorizontal: 24
        borderWidth:1, 
        borderRadius: 40, 
        borderColor: theme.surfaceBorder,
      }} //match figma
      styleText={{
        fontSize: 18, 
        lineHeight: 21.6, 
        letterSpacing: -0.5, 
        color: theme.accent 
      }} //match figma
    >
      {label}
    </DS.Button>
  )
}*/

const styles = StyleSheet.create({
  btn: {
    borderRadius: 40,
    alignItems: 'center',
    paddingVertical: 14,
    paddingHorizontal: 24,
    borderWidth: 1
  }
})

export { 
  PrimaryBtn, 
  SecondaryBtn, 
  CthPrimaryBtn, 
  CthSecondaryBtn, 
  D10PrimaryBtn, 
  D10SecondaryBtn,
  PocketPickPrimaryBtn, 
  PocketPickSecondaryBtn 
}
